/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiTabbar from './lui-tabbar'
import LuiTab from './lui-tab'
import luiTabbarGlobal from 'lui-tabbar.global.scss'
import luiTabGlobal from 'lui-tab.global.scss'

window.lui.registerComponent(LuiTabbar, luiTabbarGlobal)
window.lui.registerComponent(LuiTab, luiTabGlobal)



//////////////////
// WEBPACK FOOTER
// ./packages/lui-tabbar/index.js
// module id = 337
// module chunks = 0 1 6